export const irisSectors = [
    {
        name: "Energy",
        industryMasterName: "Energy",
    },
    {
        name: "Financials",
        industryMasterName: "Financials",
    },
    {
        name: "Diversified",
        industryMasterName: "Diversified",
    },
    {
        name: "Healthcare",
        industryMasterName: "Healthcare",
    },
    {
        name: "Miscellaneous",
        industryMasterName: "Miscellaneous",
    },
    {
        name: "Industrials",
        industryMasterName: "Industrials",
    },
    {
        name: "Technology",
        industryMasterName: "Technology",
    },
    {
        name: "Utilities",
        industryMasterName: "Utilities",
    },
    {
        name: "Real Estate",
        industryMasterName: "Real Estate",
    },
    {
        name: "Consumer Cyclicals",
        industryMasterName: "Consumer Cyclicals",
    },
    {
        name: "Consumer Non-Cyclicals",
        industryMasterName: "Consumer Non-Cyclicals",
    },
];

export const irisRegions = [
    {
        name: "India",
        exchanges: ["NSE", "BSE"],
    },
    {
        name: "USA",
        exchanges: ["NASDAQ", "NYSE"],
    },
];
